// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"Logo_logoWrapper__G4dC2","logoLink":"Logo_logoLink__HEKVg","logo":"Logo_logo__tgA6F","shape":"Logo_shape__HBJh9","newsroomShape":"Logo_newsroomShape__fW8HT"};